module.exports = __webpack_public_path__ + "img/48.7a960052.svg";